export const getRecommendatorHost = ({ context }) => {
  const environment = context?.environment || {};
  const localEndpoint = process.env.NEXT_PUBLIC_RECOMENDATOR_LOCAL_ENDPOINT;
  const fallbackEndpoint = environment['ssr-backend']?.endpoint;

  if (environment.name === 'local' && localEndpoint) {
    return localEndpoint;
  }

  if (environment.name === 'local' && environment['ssr-backend']?.endpoint) {
    return environment['ssr-backend'].endpoint;
  }

  return fallbackEndpoint;
};

export default getRecommendatorHost;
